import { useProviderAvailability } from '../../api/scheduleAppointment/useProviderAvailability';
import { useUserPublicInfo } from '../../api/public/useUserPublicInfo';
import { useCoachAvailability } from '../../api/scheduleAppointment/useCoachAvailability';
import { CareModel } from '../../api/types';
import { useMemo } from 'react';

export enum AvailabilityType {
  coach = 'coach',
  provider = 'provider',
}

export const useFetchAvailability = ({
  endDate,
  startDate,
  userId,
}: {
  endDate: Date;
  startDate: Date;
  userId: string | undefined;
}) => {
  const from = useMemo(
    () => startDate.toISOString().split('T')[0],
    [startDate]
  );
  const to = useMemo(() => endDate.toISOString().split('T')[0], [endDate]);

  const { data: userPublicData, isLoading: loadingUserPublicData } =
    useUserPublicInfo(userId);

  const { data: providerAvailability, isLoading: loadingProviderAvailability } =
    useProviderAvailability({
      care_model: userPublicData?.care_model,
      end_date: to,
      start_date: from,
      timezone: userPublicData?.timezone,
      user_id: userId,
    });

  const { data: coachAvailability, isLoading: loadingCoachAvailability } =
    useCoachAvailability({
      care_model: userPublicData?.care_model,
      coach_uuid: userPublicData?.coach_id,
      end_date: to,
      start_date: from,
      timezone: userPublicData?.timezone,
    });

  return {
    availabilityResponse: providerAvailability || coachAvailability,

    availabilityType:
      userPublicData?.care_model === CareModel.Collaborative
        ? AvailabilityType.provider
        : AvailabilityType.coach,

    isLoading:
      loadingUserPublicData ||
      (userPublicData?.care_model === CareModel.Collaborative &&
        loadingProviderAvailability) ||
      (userPublicData?.care_model === CareModel.CoachOnly &&
        loadingCoachAvailability),

    isStripe: userPublicData?.is_stripe,

    referrer: userPublicData?.referrer,

    timezone: userPublicData?.timezone,
  };
};
